import React, { useState, useEffect } from 'react';
import './Footer.css';

/* Multi idioma */
import { FormattedMessage } from 'react-intl';

const Footer = () => {
    // Fecha
    let fecha = new Date().getFullYear();
    const [isVisible, setIsVisible] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        setIsVisible(true);
        return () => setIsVisible(false);
    }, []);

    return (
        <footer className={`footer ${isVisible ? 'visible' : ''}`}>
            <div className="footer-wave">
                <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
                </svg>
            </div>
            
            <div className="site-footer">
                <div className="footer-content">
                    <div className="footer-info">
                        <div className="copyright" data-aos="fade-up" data-aos-delay="200">
                            <p>
                                <FormattedMessage
                                    id='footer-info'
                                    defaultMessage='Page created with ❤️ by Arun Singh'
                                />
                            </p>
                            <p>&copy; {fecha}. All Rights Reserved.</p>
                        </div>
                        
                        <div className="footer-quote">
                            <p data-aos="fade-up" data-aos-delay="300">
                                <FormattedMessage
                                    id='footer-quote'
                                    defaultMessage='Turning ideas into digital reality'
                                />
                            </p>
                        </div>
                    </div>
                    
                    <div className="footer-social" data-aos="fade-up" data-aos-delay="400">
                        <div className="redes-sociales">
                            {[
                                { 
                                    url: "https://www.linkedin.com/in/arun-singh-5a0237303", 
                                    icon: "fab fa-linkedin",
                                    color: "#0077B5"
                                },
                                { 
                                    url: "https://github.com/Arunchy07", 
                                    icon: "fab fa-github",
                                    color: "#333"
                                },
                                { 
                                    url: "https://www.instagram.com/arun_ch0udhary_/", 
                                    icon: "fab fa-instagram",
                                    color: "#E1306C"
                                },
                                { 
                                    url: "https://api.whatsapp.com/send?phone=918082065540", 
                                    icon: "fab fa-whatsapp",
                                    color: "#25D366"
                                }
                            ].map((social, index) => (
                                <a 
                                    key={index}
                                    href={social.url} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{ '--social-color': social.color }}
                                    className="social-icon"
                                >
                                    <i className={social.icon}></i>
                                    <span className="tooltip">{social.icon.split('-')[1]}</span>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
                
            </div>
            
            <button className="scroll-to-top" onClick={scrollToTop} aria-label="Scroll to top">
                <i className="fas fa-arrow-up"></i>
            </button>
        </footer>
    );
};

export default React.memo(Footer);